"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Close = _interopRequireDefault(require("@mui/icons-material/Close"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _AccountCircle = _interopRequireDefault(require("@mui/icons-material/AccountCircle"));
var _UserProfileCardModule = _interopRequireDefault(require("./UserProfileCard.module.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const UserProfileCard = _ref => {
  let {
    nickName,
    onClose
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: _UserProfileCardModule.default.Userdetails
  }, /*#__PURE__*/_react.default.createElement(_AccountCircle.default, null), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("h4", null, nickName)), onClose && /*#__PURE__*/_react.default.createElement(_Close.default, {
    className: _UserProfileCardModule.default.closeIcon,
    onClick: onClose
  }));
};
UserProfileCard.propTypes = {
  nickName: _propTypes.default.string,
  onClose: _propTypes.default.func
};
var _default = exports.default = UserProfileCard;